<template>
  <div class="hero">
    <div class="hero-content d-flex justify-content-center align-items-center">
      <h1>Árnyékguru Blog - Szúnyogháló útmutató 🦟</h1>
    </div>
  </div>
  <div class="blog-body">
    <h1 data-aos="fade-up"><i class="bi bi-shield-check"></i> Szúnyogháló típusok és megoldások</h1>

    <p data-aos="fade-up" data-aos-delay="100">
      A szúnyogháló egy praktikus és nélkülözhetetlen kiegészítője otthonunknak, amely védelmet nyújt a szúnyogok és egyéb rovarok ellen, miközben lehetővé teszi a friss levegő szabad áramlását.
      Azonban a piacon számos típus és megoldás létezik, amelyek különböznek anyagukban, funkcionalitásukban és árukban.
      Ebben az útmutatóban megismerkedünk a leggyakoribb szúnyogháló típusokkal, hogy megtalálhasd az otthonodnak legmegfelelőbb megoldást.
    </p>

    <img src="../../public/static/assets/blog/szunyoghalo/hero.webp" alt="Szúnyogháló beépítés Veszprém - egyedi szúnyogháló megoldás" data-aos="zoom-in" data-aos-duration="600">

    <h2 data-aos="fade-up"><i class="bi bi-pin"></i> Alapvető besorolás</h2>

    <p data-aos="fade-up" data-aos-delay="100">
      Két fő típust különböztetünk meg: a <strong>fix (rögzített)</strong> és a <strong>mozgatható (nyitható)</strong> szúnyoghálókat.
      A fix hálók állandó védelmet nyújtanak, míg a mozgatható típusok rugalmasságot biztosítanak.
      A választás függ az ablak vagy ajtó méretétől, alakjától, és az Ön igényeitől.
    </p>

    <section>
      <h2><i class="bi bi-window"></i> Fix szúnyogháló típusok</h2>
      <p><em>Előnyei: olcsó, egyszerű, praktikus, nem igényel karbantartást</em></p>

      <ul>
        <li data-aos="fade-up" data-aos-delay="0">
          <strong><span class="badge-num">1</span>Műanyag fix keretes</strong>
          <p>
            Az egyik legegyszerűbb és legolcsóbb megoldás. Egyszerűen, gyorsan felszerelhető földszinti lakásoknál,
            akár redőny elé közvetlenül rögzíthető. Praktikus és megfizethető választás azok számára, akik egyszerű védelmet keresnek.
          </p>
        </li>

        <li data-aos="fade-up" data-aos-delay="100">
          <strong><span class="badge-num">2</span>Alumínium fix keretes</strong>
          <p>
            Egy magasabb szintű megoldás a műanyaghoz képest. Az alumínium keret időtálló, diszkrét és vékony,
            sokféle szín variációban elérhető — faerezetes kivitelben, például dió, aranytölgy vagy mahagóni színekben.
            Kiváló hosszú távú beruházás, amely esztétikailag is megújítja az ablak kinézetét.
          </p>
        </li>

        <li data-aos="fade-up" data-aos-delay="200">
          <strong><span class="badge-num">3</span>Peremes fix</strong>
          <p>
            Különlegessége az elforgatható „fülekkel" ellátott konstrukció, amely könnyen beilleszthető az ablak peremébe.
            Ez a típus ideális emeletes lakásoknál, mivel a hálót könnyen ki- és bevehető, ami könnyebbé teszi a tisztítást és karbantartást.
          </p>
          <img src="../../public/static/assets/blog/szunyoghalo/peremes.jpg" alt="Peremes fix szúnyogháló Veszprém - szúnyogháló javítás és beépítés" data-aos="zoom-in" data-aos-duration="600" />
        </li>

        <li data-aos="fade-up" data-aos-delay="300">
          <strong><span class="badge-num">4</span>Kefés falcos</strong>
          <p>
            Alumínium keretes kivitel, amely könnyen benyomható az ablak peremébe.
            A keret körbe kefézett, amely maximalizálja az illeszkedést és biztosítja, hogy egyetlen rovar se tudjon bejutni.
          </p>
        </li>
      </ul>
    </section>

    <section>
      <h2><i class="bi bi-door-closed"></i> Mozgatható, nyitható szúnyogháló típusok</h2>
      <p><em>Rugalmasság és további funkciók</em></p>

      <ul>
        <li data-aos="fade-up" data-aos-delay="0">
          <strong><span class="badge-num">1</span>Rolós „mobil" szúnyogháló ablakra</strong>
          <p>
            Függőlegesen könnyen fel/le mozgatható a rugó ellenében, saját 5 cm-es tokjába visszahúzódó háló, ami ezáltal kis helyre is beépíthető.
          </p>
          <img src="../../public/static/assets/blog/szunyoghalo/mozgathato-mobil-ablak.jpg" alt="Rolós mobil szúnyogháló ablakra Balatonfüred - egyedi szúnyogháló megoldás" data-aos="zoom-in" data-aos-duration="600" />
        </li>

        <li data-aos="fade-up" data-aos-delay="100">
          <strong><span class="badge-num">2</span>Rolós „mobil" szúnyogháló ajtóra</strong>
          <p>
            Vízszintes mozgatású, szúnyogháló ajtó helyett, kis teraszoknál, francia erkélyen alkalmazható, nagyobb szélességnél, akár kéttokos (két oldalról összehúzható). Nagy magasságnál nehezen kezelhető.
          </p>
          <img src="../../public/static/assets/blog/szunyoghalo/mozgathato-mobil-ajto.jpg" alt="Rolós mobil szúnyogháló ajtóra Veszprém - szúnyogháló javítás" data-aos="zoom-in" data-aos-duration="600" />
        </li>

        <li data-aos="fade-up" data-aos-delay="200">
          <strong><span class="badge-num">3</span>Nyíló ajtó</strong>
          <p>
            Alumínium keretes, rejtett fogantyúval, zsanérról könnyen leemelhető, mágnessel jól zárodó, egyszerűen kezelhető, redőny elé felhelyezhető.
          </p>
          <img src="../../public/static/assets/blog/szunyoghalo/ajto.jpg" alt="Nyíló ajtó szúnyogháló Balatonfüred - egyedi szúnyogháló beépítés" data-aos="zoom-in" data-aos-duration="600" />
        </li>

        <li data-aos="fade-up" data-aos-delay="300">
          <strong><span class="badge-num">4</span>Toló pályás</strong>
          <p>
            Alumínium kereten belül könnyen csúsztatható, masszív ajtó(k). Terasz ajtók, redőnyök elé alkalmazhatók, egy vagy két pályásak lehetnek. Drágább, de tartós megoldás.
          </p>
          <img src="../../public/static/assets/blog/szunyoghalo/tolo-palyas.jpg" alt="Toló pályás szúnyogháló Veszprém - professzionális szúnyogháló javítás és beépítés" data-aos="zoom-in" data-aos-duration="600" />
        </li>

        <li data-aos="fade-up" data-aos-delay="400">
          <strong><span class="badge-num">5</span>Pliszé</strong>
          <p>
            A legmodernebb és legkomplexebb megoldás. Kis helyen elfér, és bárhol megállítható.
            Jellegzetessége, hogy a szerkezet harmonika szerűen nyitja és gyűjti a halót,
            amely exkluzív és elegáns megjelenést biztosít. Ez egy premium megoldás, drágább, de kiváló esztétikát ad.
            Azonban kisállatokkal való otthonban nem ajánlott, mivel könnyebben megsérülhet.
          </p>
          <img src="../../public/static/assets/blog/szunyoghalo/plisze.jpg" alt="Pliszé szúnyogháló Balatonfüred - egyedi szúnyogháló megoldás" data-aos="zoom-in" data-aos-duration="600">
        </li>
      </ul>
    </section>

    <section>
      <h2><i class="bi bi-house-fill"></i> Melyiket válasszam?</h2>
      <p>
        A szúnyogháló típusának választása számos tényezőtől függ:
      </p>
      <ul>
        <li><strong>Ablak/ajtó típusa:</strong> Az ablak vagy ajtó mérete és formája meghatározza, mely típusok alkalmazhatók.</li>
        <li><strong>Költségvetés:</strong> Fix keretes típusok olcsóbbak, míg a pliszé és toló pályás megoldások prémium árkategóriában vannak.</li>
        <li><strong>Élettartam:</strong> Az alumínium és toló pályás típusok hosszabb élettartamot ígérnek.</li>
        <li><strong>Esztétika:</strong> Az alumínium és pliszé megoldások elegánsabbak, és jobban integráljódnak az otthon stílusába.</li>
        <li><strong>Karbantartás igénye:</strong> A fix típusok gyakorlatilag karbantartás mentesek, míg a mozgatható típusokat rendszeres tisztítás igényli.</li>
      </ul>
    </section>

    <section>
      <h2><i class="bi bi-lightbulb"></i> Hasznos tanácsok</h2>
      <ul>
        <li>Mindig mérd meg az ablak vagy ajtó pontos méreteit a vásárlás / rendelés előtt.</li>
        <li>Az extrém többszögű vagy íves ablakokra is szerelhető fix szúnyogháló.</li>
        <li>A mozgatható típusok általában drágábbak a szerkezeti adottságaik miatt.</li>
        <li>Válassz tisztító barát típusokat, ha állatok vagy kisgyerekek vannak az otthonban.</li>
      </ul>
    </section>

    <div class="tip">
      <i class="bi bi-bug"></i> Szeretnél szúnyoghálót beépíteni? Megbízhatsz bennünk — ideális megoldást választunk ki az Ön otthonához,
      és professionálisan szereljük fel, hogy teljes védelem alatt legyen!
    </div>

    <div class="d-flex justify-content-center">
      <PhoneComponent/>
    </div>
  </div>
</template>

<script>

import PhoneComponent from "@/components/PhoneComponent.vue";

export default {
  name: 'SzunyoghhaloPage',
  data() {
    return {
    };
  },
  components: {
    PhoneComponent
  }
}

</script>

<style scoped lang="scss">
@use '@/assets/style/variables';
@use '@/assets/style/blog';

.header-placeholder {
  height: 65px;
}

.hero {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 500px;
}

.hero::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(../../public/static/assets/blog/szunyoghalo/hero.webp);
  background-repeat: no-repeat;
  background-position: center bottom 25%;
  filter: brightness(80%);
  background-attachment: fixed;
  background-size: cover;
}

.hero-content {
  position: relative;
  color: variables.$light-color;
  padding: 20px;
}

@media screen and (max-width: 800px) {
  .hero {
    background: url(../../public/static/assets/blog/szunyoghalo/hero.webp);
    background-size: cover;
    height: 300px;
  }

  .hero::before {
    background: none !important;
  }

  .hero-content {
    position: relative;
    color: variables.$light-color;
    padding: 20px;
    background: #000;
    opacity: 0.5;
    width: 100%;
    height: 100%;
  }
}
</style>
